import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../StateContext/Application';
import { apiurl } from '../../../../path';
import { Link, useNavigate } from 'react-router-dom';
import "./rejectpanel.css";
import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../public/LoginImages/importimages';
import { useLanguage } from '../../../../lang/langcontext/LanguageContext';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from 'html2canvas';
import { useDepartmentFilter } from '../../../../utils/DateFormat';

const ProposalInwardStateWise = () => {
 const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext)
    const { GetProposalInwardsList, ProposalApprovalOperation, CreateToken, GetMyDepartmentAccess } = context;

    const { departments, departmentId, setDepartmentId, ready } = useDepartmentFilter(GetMyDepartmentAccess);

    const nav = useNavigate();
    const [technicalInwards, setTechnicalInwards] = useState([])
    const [loading, setLoading] = useState(false);
    const [rejectPanelhide, setRejectpanelhide] = useState(1);
    const [remark, setRemark] = useState("");
    const [selectedBills, setSelectedBills] = useState([]);
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');
    const [SelectedOptions, setSelectedOptions] = useState("");
      const [selectedDistrict, setSelectedDistrict] = useState("");
      const [selectedTaluka, setSelectedTaluka] = useState("");
      const [exportingPDF, setExportingPDF] = useState(false);

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
//    const sortedBills = Array.isArray(filteredBills)? filteredBills.slice() // ✅ prevent state mutation
// .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
//         : [];
const sortedBills= filteredBills;
    const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
    // const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
    const [hide, sethide] = useState(true)
    const [Etoken, SetEtoken] = useState(false)
    const [GenerateToken, SetGenerateToken] = useState(true)
    const [GenerateRejectToken, SetGenerateRejectToken] = useState(true)
    const [selectedWorkNames, setSelectedWorkNames] = useState([]);
      const [selectedHeadCode, setSelectedHeadCode] = useState("");

    async function GenerateTokenFor(e) {
        e.preventDefault();
        let data = await CreateToken('Proposal Approval');
        document.getElementById('tokencopys').innerText = data
        SetEtoken(data)
        sethide(false)
    }

    const getTechnicalInwardsList = async () => {
      let data = await GetProposalInwardsList('State', 'All', '', departmentId);
      const list = Array.isArray(data) ? data : [];
      setTechnicalInwards(list);
      setFilteredBills(list);
    };
    
    useEffect(() => {
      if (!ready) return;
      getTechnicalInwardsList();
    }, [ready, departmentId]);

    let inwardList = []
    if (technicalInwards.length > 0) {
        inwardList = technicalInwards
    }
    // useEffect(() => {
    //     const lowerSearchTerm = searchTerm.toLowerCase();
    //     const filtered = technicalInwards.filter(bill =>
    //         Object.values(bill).some((val) =>
    //             (val || '').toString().toLowerCase().includes(lowerSearchTerm)
    //         )
    //     );
    //     setFilteredBills(filtered);
    //     setCurrentPage(1);
    // }, [searchTerm, technicalInwards]);

//   useEffect(() => {
//     const lowerSearchTerm = searchTerm.toLowerCase();

//     const filtered = technicalInwards.filter((bill) => {
//       // Search filter
//       const matchesSearch = Object.values(bill).some((val) =>
//         (val || "").toString().toLowerCase().includes(lowerSearchTerm),
//       );

//       // HeadCode filter
//       const matchesHeadCode =
//         selectedHeadCode === "" || bill.HeadCode.startsWith(selectedHeadCode);

//      const itemDistrict = bill?.District || "";

// const matchesDistrict =
//   selectedDistrict === "" ||
//   itemDistrict === selectedDistrict ||
//   itemDistrict.startsWith(`${selectedDistrict}-`);

//       const matchesTaluka =
//         selectedTaluka === "" ||
//         bill.Taluka === selectedTaluka;

//       return matchesSearch && matchesHeadCode && matchesDistrict && matchesTaluka;
//     });

//     setFilteredBills(filtered);
//     setCurrentPage(1);
//   }, [searchTerm, selectedHeadCode, selectedDistrict,
//     selectedTaluka,
//     technicalInwards,]);

useEffect(() => {
  const lowerSearchTerm = searchTerm.toLowerCase();

  const filtered = technicalInwards.filter((bill) => {
    const matchesSearch = Object.values(bill).some((val) =>
      (val || "").toString().toLowerCase().includes(lowerSearchTerm),
    );

    const matchesHeadCode =
      selectedHeadCode === "" || bill.HeadCode.startsWith(selectedHeadCode);

    const itemDistrict = bill?.District || "";
    const matchesDistrict =
      selectedDistrict === "" ||
      itemDistrict === selectedDistrict ||
      itemDistrict.startsWith(`${selectedDistrict}-`);

    const matchesTaluka =
      selectedTaluka === "" || bill.Taluka === selectedTaluka;

    // ✅ NEW: status filter
    const matchesStatus =
      SelectedOptions === "" || bill.Status === SelectedOptions;

    return (
      matchesSearch &&
      matchesHeadCode &&
      matchesDistrict &&
      matchesTaluka &&
      matchesStatus
    );
  });

  setFilteredBills(filtered);
  setCurrentPage(1);
}, [
  searchTerm,
  selectedHeadCode,
  selectedDistrict,
  selectedTaluka,
  SelectedOptions, 
  technicalInwards,
]);

    useEffect(() => {
  setSelectedTaluka("");
}, [selectedDistrict]);

    // const handleCheckboxChange = (id) => {
    //     setSelectedBills((prevSelected) =>
    //         prevSelected.includes(id)
    //             ? prevSelected.filter((billId) => billId !== id)
    //             : [...prevSelected, id]
    //     );
    // };

    const handleCheckboxChange = (proposalId, workName) => {
        if (selectedBills.includes(proposalId)) {
            setSelectedBills(selectedBills.filter((id) => id !== proposalId));
            setSelectedWorkNames(selectedWorkNames.filter((name) => name !== workName));
        } else {
            setSelectedBills([...selectedBills, proposalId]);
            setSelectedWorkNames([...selectedWorkNames, workName]);
        }
    };

    console.log("Slected id form table :: ", selectedBills);
    console.log("Filtered data id form table :: ", filteredBills);

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedBills(currentBills.map((bill) => bill.ProposalID));
            setSelectedWorkNames(currentBills.map((bill) => bill.Work_name));
        } else {
            setSelectedBills([]);
            setSelectedWorkNames([]);
        }
    };

    const approveorrejectSelected = async (condition) => {
        if (selectedBills.length === 0) {
            alert('No Proposal selected for approval!');
            return;
        }
        console.log(selectedBills);
        setLoading(true); // Start loader


        try {
            let response = await ProposalApprovalOperation(selectedBills, condition, remark, Etoken, selectedWorkNames); // Call backend function
            if (response.message) {
                alert(response.message);
                window.location.reload()
                setRemark("");
                setRejectpanelhide(false)
                getTechnicalInwardsList(); // Refresh the list after approval
            }
            if (response.error) {
                alert(response.error)
                window.location.reload()
                getTechnicalInwardsList(); // Refresh the list after approval
            }
        } catch (error) {
            console.error('Error approving Proposal:', error);
            alert('An error occurred while approving bills.');
        }
        setLoading(false); // Stop loader
    };

    // return (
    //     <>

    //         <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>

    //             <div className='col-12 px-3 m-auto'>


    //                 <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    //                     {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
    //                     <h5 className='my-auto fw-bold'>
    //                         <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
    //                         <span className='my-auto'>Proposal Approval ( State Wise )</span>
    //                     </h5>
    //                     {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)}
    //                                 value={searchTerm}
    //                                 style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}

    //                     <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
    //                         <img
    //                             src="/Search32.png"
    //                             alt="Search Icon"
    //                             style={{
    //                                 position: "absolute",
    //                                 top: "50%",
    //                                 left: "10px",
    //                                 transform: "translateY(-50%)",
    //                                 width: "16px",
    //                                 height: "16px",
    //                                 opacity: 0.6
    //                             }}
    //                         />
    //                         <input
    //                             type="text"
    //                             placeholder="Search Here"
    //                             onChange={(e) => setSearchTerm(e.target.value)}
    //                             value={searchTerm}
    //                             style={{
    //                                 width: "100%",
    //                                 padding: "8px 12px 8px 32px", // left padding makes space for icon
    //                                 border: "1px solid #ccc",
    //                                 borderRadius: "8px",
    //                                 backgroundColor: "#f1f6fc",
    //                                 fontSize: "14px",
    //                                 color: "#333",
    //                                 boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    //                                 outline: "none"
    //                             }}
    //                         />
    //                     </div>
    //                 </div>

    //                 <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "30px 30px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
    //                     <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
    //                         <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
    //                             <thead>
    //                                 <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
    //                                     {/* <th style={{ width: "4%", textAlign: "center" }} >
    //                                         <input
    //                                             type="checkbox"
    //                                             onChange={handleSelectAll}
    //                                             checked={selectedBills.length > 0 && selectedBills.length === currentBills.length}
    //                                             className='my-auto'
    //                                             style={{ height: '1rem', width: '1rem' }}
    //                                         />
    //                                     </th> */}
    //                                     <th style={{ width: "8%" }}>View</th>
    //                                     <th style={{ width: "10%" }}>Proposal ID</th>
    //                                     <th style={{ width: "8%" }}>HeadCode</th>
    //                                     <th style={{ width: "8%" }}>Proposal Year</th>
    //                                     {/* <th style={{ width: "10%" }}>Scheme Name</th> */}
    //                                     <th style={{ width: "8%" }}>District</th>
    //                                     <th style={{ width: "10%" }}>Total Proposal Amount</th>
    //                                     {/* <th style={{ width: "10%" }}>Location</th> */}

    //                                 </tr>
    //                             </thead>
    //                             <tbody>
    //                                 {
    //                                     currentBills.length <= 0 ?
    //                                         (
    //                                             <tr>
    //                                                 <td colSpan="30" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
    //                                                     No data available
    //                                                 </td>
    //                                             </tr>
    //                                         )
    //                                         :
    //                                         (
    //                                             currentBills?.map((technicalInwards, index) => {
    //                                                 const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
    //                                                 return (
    //                                                     <tr style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }} key={index}>
    //                                                         {/* <td style={{ textAlign: "center" }}>
    //                                                             <input
    //                                                                 type="checkbox"
    //                                                                 className='my-auto'
    //                                                                 style={{ height: '1rem', width: '1rem' }}
    //                                                                 checked={selectedBills.includes(technicalInwards.ProposalID)}
    //                                                                 onChange={() => handleCheckboxChange(technicalInwards.ProposalID, technicalInwards.Work_name)}
    //                                                             />
    //                                                         </td> */}
    //                                                         <td className='py-2'>
    //                                                             <button
    //                                                                 onClick={() => nav(`/AdminDashboard/ProposalApprove/${technicalInwards.workuniqueid}?page=${currentPage}`, {
    //                                                                     state: {
    //                                                                         type: "State"
    //                                                                     }
    //                                                                 })}
    //                                                                 className='m-auto text-center'
    //                                                                 style={{
    //                                                                     width: "4rem", fontWeight: "600", padding: "7px 3px", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.1rem",
    //                                                                     background: 'linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)',
    //                                                                     color: 'white', borderRadius: '8px',
    //                                                                 }}
    //                                                             > <img src='/view32.png' style={{ width: '0.9rem', height: "0.9rem", filter: 'brightness(0) invert(1)' }} />
    //                                                                 View
    //                                                             </button>
    //                                                         </td>
    //                                                         <td className='py-2'>{technicalInwards.workuniqueid}</td>
    //                                                         <td className='py-2'>{technicalInwards.HeadCode}</td>
    //                                                         <td className='py-2'>{technicalInwards.Proposal_year}</td>
    //                                                         {/* <td className='py-2'>{technicalInwards.SchemeName}</td> */}
    //                                                         <td className='py-2'>{technicalInwards.District}</td>
    //                                                         <td style={{ padding: '8px' }}>{`${technicalInwards.TotalProposalAmount}`}</td>
    //                                                         {/* <td style={{ padding: '8px' }}>
    //                                                             <button
    //                                                                 onClick={() => nav(`/AdminDashboard/ShowMapProposal/${encodeURIComponent(technicalInwards.Work_name)}`)}
    //                                                                 style={{
    //                                                                     display: 'flex',
    //                                                                     alignItems: 'center',
    //                                                                     gap: '0.4rem',
    //                                                                     padding: '6px 10px',
    //                                                                     fontWeight: '700',
    //                                                                     fontSize: '13px',
    //                                                                     color: '#357EDC',
    //                                                                     backgroundColor: '#E8F0FE',
    //                                                                     borderRadius: '6px',
    //                                                                     cursor: 'pointer',
    //                                                                     transition: 'all 0.2s ease-in-out'
    //                                                                 }}
    //                                                             >
    //                                                                 <img
    //                                                                     src='/Go-To-Map32.png'
    //                                                                     alt='Go to Map'
    //                                                                     style={{ width: '1rem', height: '1rem' }}
    //                                                                 />
    //                                                                 Go to Map
    //                                                             </button>
    //                                                         </td> */}


    //                                                     </tr>
    //                                                 )
    //                                             })
    //                                         )
    //                                 }
    //                             </tbody>
    //                         </table>
    //                     </div>

    //                     <div className='col-12 mt-3'>

    //                         <div
    //                             className="my-2 d-flex justify-content-between align-items-center"
    //                             style={{ flexWrap: "wrap" }}
    //                         >


    //                             <p>Showing {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}  to {Math.min(indexOfLastBill, filteredBills?.length)} of {filteredBills?.length} entries</p>
    //                             <div className="col-6 text-end">
    //                                 {/* First Page Button */}
    //                                 <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
    //                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
    //                                     &laquo;
    //                                 </button>
    //                                 {/* Previous Button */}
    //                                 <button
    //                                     onClick={() => setCurrentPage(currentPage - 1)}
    //                                     disabled={currentPage === 1}
    //                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                     &lt;
    //                                 </button>

    //                                 <button
    //                                     style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
    //                                 </button>
    //                                 {/* Next Button */}
    //                                 <button
    //                                     onClick={() => setCurrentPage(currentPage + 1)}
    //                                     disabled={currentPage === totalPages}
    //                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                     &gt;
    //                                 </button>
    //                                 {/* Last Page Button */}
    //                                 <button
    //                                     onClick={() => setCurrentPage(totalPages)}
    //                                     disabled={currentPage === totalPages}
    //                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                     &raquo;
    //                                 </button>
    //                             </div>

    //                             <div className='col-6 text-start' style={{ display: 'flex', justifyContent: 'left' }}>
    //                                 <button
    //                                     onClick={() => approveorrejectSelected("Approved")}
    //                                     disabled={selectedBills.length <= 0 ? true : loading}
    //                                     className='ms-0'
    //                                     // onClick={(e) => { SetGenerateToken(false) }}
    //                                     style={{
    //                                         display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
    //                                         backgroundColor: selectedBills.length <= 0 ? (
    //                                             'rgba(141, 141, 141, 0.97)'
    //                                         ) : ('#39B54A'),
    //                                         color: 'white', borderRadius: '8px',
    //                                         cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
    //                                     }}
    //                                 ><img src='/Approve-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
    //                                 </button>

    //                                 <button
    //                                     onClick={() => setRejectpanelhide(2)}
    //                                     // onClick={(e) => { SetGenerateRejectToken(false) }}
    //                                     disabled={selectedBills.length <= 0 ? true : loading}
    //                                     style={{
    //                                         display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
    //                                         background: selectedBills.length <= 0 ? (
    //                                             'rgba(141, 141, 141, 0.97)'
    //                                         ) : ('#C1272D'),
    //                                         color: 'white', borderRadius: '8px',
    //                                         cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
    //                                     }}
    //                                 ><img src='/Reject-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Reject Selected'}
    //                                 </button>

    //                                 <button
    //                                     onClick={() => setRejectpanelhide(3)} disabled={selectedBills.length <= 0 ? true : loading}
    //                                     style={{
    //                                         display: 'flex', alignItems: 'center', gap: '3px', margin: '12px', padding: '8px 10px', fontWeight: "600",
    //                                         background: selectedBills.length <= 0 ? (
    //                                             'rgba(141, 141, 141, 0.97)'
    //                                         ) : ('linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)'),
    //                                         color: 'white', borderRadius: '8px',
    //                                         cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
    //                                     }}
    //                                 ><img src='/Send-Back-Selected32.png' style={{ width: '1rem', height: "1rem", filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Send Back Selected'}
    //                                 </button>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>

    //             </div>


    //             {
    //                 rejectPanelhide === 2 &&

    //                 <div className='col-12 RejectPanelContainer'>
    //                     <div className="Rejectpanel">
    //                         <form action="">

    //                             <div className="col-12 elements">
    //                                 <div className="row">
    //                                     <div className="col-3">
    //                                         <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
    //                                     </div>
    //                                     <div className="col-8">
    //                                         <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
    //                                         </textarea>
    //                                     </div>
    //                                 </div>
    //                             </div>

    //                         </form>
    //                         <div className="col-12 ms-auto my-4">
    //                             <div className="row">
    //                                 <div className="col-9 m-auto">
    //                                     <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
    //                                         <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")}><img src={submit} style={{ width: '15px' }} /> Reject</button>
    //                                         <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>

    //                 </div>

    //             }

    //             {
    //                 rejectPanelhide === 3 &&

    //                 <div className='col-12 RejectPanelContainer'>
    //                     <div className="Rejectpanel">
    //                         <form action="">

    //                             <div className="col-12 elements">
    //                                 <div className="row">
    //                                     <div className="col-3">
    //                                         <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
    //                                     </div>
    //                                     <div className="col-8">
    //                                         <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
    //                                         </textarea>
    //                                     </div>
    //                                 </div>
    //                             </div>

    //                         </form>
    //                         <div className="col-12 ms-auto my-4">
    //                             <div className="row">
    //                                 {/* <div className="col-3"></div> */}
    //                                 <div className="col-9 m-auto">
    //                                     <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
    //                                         <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("SendBack")}><img src={submit} style={{ width: '15px' }} /> Send Back</button>
    //                                         <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             }

    //             {/* <div className="card">
    //                         <div style={{ position: "fixed", padding: "10rem", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} hidden={GenerateToken}>
    //                             <div class="card-body" style={{ backgroundColor: "white", width: "50%" }}>
    //                                 <h6>Send Message</h6>
    //                                 <div class="card form-control" style={{ width: "100%" }}>
    //                                     <div class="card-body">
    //                                         <h5 class="card-title">Generate Token</h5>
    //                                         <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
    //                                         <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>
        
    //                                     </div>
    //                                 </div>
    //                                 <button
    //                                     onClick={() => approveorrejectSelected("Approved")} hidden={hide}
    //                                     style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '12px', padding: '8px 15px', background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
    //                                 ><img style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
    //                                 </button>
    //                                 <button className='btn btn-success mx-2 my-2' onClick={() => Approve(selectedType)} hidden={hide} >Approve</button>
    //                                 <button className='btn btn-danger' onClick={(x) => { SetGenerateToken(true); SetEtoken("") }}>close</button>
    //                             </div>
    //                         </div>
    //                     </div>
        
    //                     <div className="card">
    //                         <div style={{ position: "fixed", padding: "10rem", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} hidden={GenerateRejectToken}>
    //                             <div class="card-body" style={{ backgroundColor: "white" }}>
    //                                 <h6>Send Message</h6>
    //                                 <div class="card form-control" style={{ width: "100%" }}>
    //                                     <div class="card-body">
    //                                         <h5 class="card-title">Generate Token</h5>
    //                                         <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
    //                                         <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>
    //                                     </div>
    //                                 </div>
    //                                 <div className="form-group my-3">
    //                                     <label htmlFor="remark">Remark (Required for Rejection):</label>
    //                                     <textarea className='form-control' name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
    //                                     </textarea>
    //                                 </div>
    //                                 <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")} hidden={hide} ><img src={submit} style={{ width: '15px' }} /> Reject</button>
    //                                 <button className='btn btn-success mx-2' onClick={() => Reject(selectedType)} hidden={hide} >Reject</button>
    //                                 <button className='btn btn-danger' onClick={(x) => { SetGenerateRejectToken(true); SetEtoken("") }}>close</button>
    //                             </div>
    //                         </div>
    //                     </div> */}

    //         </div >

    //     </>
    // )


      // Current page total
  const pageTotal = currentBills.reduce(
    (sum, item) => sum + Number(item.TotalProposalAmount || 0),
    0
  );

  // Gross total (all filtered records)
  const grossTotal = filteredBills.reduce(
    (sum, item) => sum + Number(item.TotalProposalAmount || 0),
    0
  );


    const exportTableByClassToExcel = () => {

    const excelData = filteredBills.map((item, index) => ({
      SrNo: index + 1,
      ProposalFileNo: item.Proposal_fileNumber,
      ProposalYear: item.Proposal_year,
      District: item.District,
      Taluka: item.Taluka,
      TotalProposalAmount: item.TotalProposalAmount,
    }));

    excelData.push({
      ProposalFileNo: "",
      ProposalYear: "",
      District: "",
      Taluka: "Gross Total",
      TotalProposalAmount: grossTotal,
    });

    const worksheet =
      XLSX.utils.json_to_sheet(excelData);

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Proposal Report"
    );

    const excelBuffer =
      XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

    const data = new Blob(
      [excelBuffer],
      {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }
    );

    saveAs(data, "Proposal_Report.xlsx");
  };

  const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
    const CHUNK_SIZE = 500; // change if needed (300–500 ideal)

    setExportingPDF(true);
    setLoading(true);

    // 🔥 Allow loader to render
    await new Promise((resolve) => setTimeout(resolve, 600));

    const originalTable = document.querySelector(`.${tableClass}`);
    if (!originalTable) {
      setExportingPDF(false);
      setLoading(false);
      return;
    }

    try {
      const originalRows = originalTable.querySelectorAll("tbody tr");
      const totalRows = originalRows.length;

      for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
        const end = Math.min(start + CHUNK_SIZE, totalRows);

        // 🔥 Clone only current chunk
        // const table = originalTable.cloneNode(true);
        const table = originalTable.cloneNode(true);

        // Remove View column from PDF only
        table.querySelectorAll("tr").forEach((row) => {
          if (row.cells.length > 0) {
            row.deleteCell(0); // removes first column (View)
          }
        });
        const rows = table.querySelectorAll("tbody tr");

        rows.forEach((row, index) => {
          if (index < start || index >= end) {
            row.remove();
          }
        });

        document.body.appendChild(table);

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const topMargin = 25;
        const sideMargin = 10;
        const bottomMargin = 15;

        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");
        pdf.text(
          `${title} (${start + 1} - ${end})`,
          pageWidth / 2,
          15,
          { align: "center" }
        );

        const canvas = await html2canvas(table, {
          scale: 1,
          useCORS: true,
          backgroundColor: "#2C78DB",
        });

        const imgWidth = pageWidth - sideMargin * 2;
        const pxToMm = imgWidth / canvas.width;

        const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
        const usablePageHeightPx = usablePageHeightMm / pxToMm;

        let renderedHeight = 0;
        let pageNumber = 0;

        while (renderedHeight < canvas.height) {
          const sliceHeight = Math.min(
            usablePageHeightPx,
            canvas.height - renderedHeight
          );

          const pageCanvas = document.createElement("canvas");
          const context = pageCanvas.getContext("2d");

          pageCanvas.width = canvas.width;
          pageCanvas.height = sliceHeight;

          context.drawImage(
            canvas,
            0,
            renderedHeight,
            canvas.width,
            sliceHeight,
            0,
            0,
            canvas.width,
            sliceHeight
          );

          const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

          if (pageNumber > 0) pdf.addPage();

          pdf.addImage(
            imgData,
            "JPEG",
            sideMargin,
            topMargin,
            imgWidth,
            sliceHeight * pxToMm
          );

          renderedHeight += sliceHeight;
          pageNumber++;
        }

        pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

        document.body.removeChild(table);

        // 🔥 Small delay between chunks (prevents freeze)
        await new Promise((resolve) => setTimeout(resolve, 300));
      }
    } catch (error) {
      console.error("PDF Export Error:", error);
    } finally {
      setExportingPDF(false);
      setLoading(false);
    }
  };



     return (
            <>
    
                <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
    
                    <div className='col-12 px-3 m-auto'>
    
    
                      <div
  className="row px-4 mb-4 mt-3 align-items-center justify-content-between"
>
  {/* Title */}
  <div className="col-lg-5 col-md-6 d-flex align-items-center">
    <img
      src="/GR-Approval64.png"
      alt="Technical Approval"
      style={{ width: "24px", height: "24px" }}
      className="me-2"
    />
    <h5 className="fw-bold mb-0">
      {t("Proposal Inward ( State Wise )")}
    </h5>
  </div>

  {/* Status Filter */}

<div
  className="d-flex align-items-center gap-2 flex-wrap"
  style={{ width: "100%" ,marginTop: "15px"}}
>

  {departments.length > 1 && (
  <select
    className="form-select"
    value={departmentId}
    onChange={(e) => setDepartmentId(e.target.value)}
    style={{ width: "180px" }}
  >
    <option value="">{t("All Departments")}</option>
    {departments.map((d) => (
      <option key={d.id} value={d.id}>
        {d.name || d.id}
      </option>
    ))}
  </select>
)}

  {/* Status */}
  <select
    className="form-select"
    value={SelectedOptions}
    onChange={(e) => setSelectedOptions(e.target.value)}
    style={{ width: "180px" }}
  >
    <option value="">{t("All")}</option>
    <option value="Pending">{t("Approve")}</option>
    {/* <option value="SendBack">{t("Send Back")}</option> */}
  </select>

  {/* District */}
  <select
    className="form-select"
    value={selectedDistrict}
    onChange={(e) => setSelectedDistrict(e.target.value)}
    style={{ width: "180px" }}
  >
    <option value="">All Districts</option>

   {[
  ...new Set(
    technicalInwards
      .map((item) => item?.District?.split("-")[0]?.trim())
      .filter(Boolean)
  ),
]
  .sort()
  .map((district, index) => (
    <option key={index} value={district}>
      {district}
    </option>
  ))}
  </select>

  {/* Taluka */}
  <select
    className="form-select"
    value={selectedTaluka}
    onChange={(e) => setSelectedTaluka(e.target.value)}
    style={{ width: "180px" }}
  >
    <option value="">All Taluka</option>

                   {[...new Set(
                     technicalInwards
                       .filter((item) => {
                         if (!selectedDistrict) {
                           return true;
                         }

                         const itemDistrict = item?.District || "";

                         return (
                           itemDistrict === selectedDistrict ||
                           itemDistrict.startsWith(`${selectedDistrict}-`)
                         );
                       })
        .map((item) => item.Taluka)
    )]
      .sort()
      .map((taluka, index) => (
        <option key={index} value={taluka}>
          {taluka}
        </option>
      ))}
  </select>

  {/* Search */}
  <div style={{ position: "relative", width: "250px" }}>
    <img
      src="/Search32.png"
      alt="Search"
      style={{
        position: "absolute",
        top: "50%",
        left: "10px",
        transform: "translateY(-50%)",
        width: "16px",
        height: "16px",
        opacity: 0.6,
      }}
    />

    <input
      type="text"
      className="form-control"
      placeholder={t("Search Here")}
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      style={{
        paddingLeft: "35px",
        backgroundColor: "#f1f6fc",
      }}
    />
  </div>
</div>
</div>
            <div className="d-flex justify-content-end mt-3 mb-3 align-items-center gap-2 flex-wrap">
              <button
                className="btn btn-success"
                onClick={() =>
                  exportTableByClassToExcel(
                    filteredBills,
                    "Proposal_Status_Report.xlsx"
                  )
                }
              >
                {t("Download Excel")}
              </button>

              <button
                className="btn btn-danger"
                onClick={() =>
                  downloadTableOnlyAsPDF(
                    "ProposalstatusReport",
                    "ProposalstatusReport.pdf",
                    "Proposal Status Report"
                  )
                }
              >
                {t("Download PDF")}
              </button>
            </div>
    
                        <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "30px 30px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
                            <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
                                <table className='m-0 p-0 ProposalstatusReport' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                            {/* <th style={{ width: "4%", textAlign: "center" }} >
                                                <input
                                                    type="checkbox"
                                                    onChange={handleSelectAll}
                                                    checked={selectedBills.length > 0 && selectedBills.length === currentBills.length}
                                                    className='my-auto'
                                                    style={{ height: '1rem', width: '1rem' }}
                                                />
                                            </th> */}
                                            <th style={{ width: "8%" }}>{t("View")}</th>
                                            <th style={{ width: "10%" }}>{t("Proposal File No")}</th>
                                            {/* <th style={{ width: "8%" }}>{t("HeadCode")}</th> */}
                                            <th style={{ width: "8%" }}>{t("Proposal Year")}</th>
                                            {/* <th style={{ width: "10%" }}>Scheme Name</th> */}
                                            <th style={{ width: "8%" }}>{t("District")}</th>
                                             <th style={{ width: "10%" }}>{t("Taluka")}</th>
                                            <th style={{ width: "10%" }}>{t("Total Proposal Amount")}</th>
                                            {/* <th style={{ width: "10%" }}>Location</th> */}
    
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            currentBills.length <= 0 ?
                                                (
                                                    <tr>
                                                        <td colSpan="30" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                            {t("No data available")}
                                                        </td>
                                                    </tr>
                                                )
                                                :
                                                (
                                                    currentBills?.map((technicalInwards, index) => {
                                                        const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                        return (
                                                            <tr style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "500" }} key={index}>
                                                                {/* <td style={{ textAlign: "center" }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        className='my-auto'
                                                                        style={{ height: '1rem', width: '1rem' }}
                                                                        checked={selectedBills.includes(technicalInwards.ProposalID)}
                                                                        onChange={() => handleCheckboxChange(technicalInwards.ProposalID, technicalInwards.Work_name)}
                                                                    />
                                                                </td> */}
                                                                <td className='py-2'>
                                                                    <button
                                                                        onClick={() => nav(`/AdminDashboard/ProposalApprove/${technicalInwards.workuniqueid}?page=${currentPage}`, {
                                                                            state: {
                                                                                type: "State"
                                                                            }
                                                                        })}
                                                                        className='m-auto text-center'
                                                                        style={{
                                                                            width: "4rem", fontWeight: "600", padding: "7px 3px", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.1rem",
                                                                            background: 'linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)',
                                                                            color: 'white', borderRadius: '8px',
                                                                        }}
                                                                    > <img src='/view32.png' style={{ width: '0.9rem', height: "0.9rem", filter: 'brightness(0) invert(1)' }} />
                                                                        {t("View")}
                                                                    </button>
                                                                </td>
                                                                <td className='py-2'>{technicalInwards.Proposal_fileNumber}</td>
                                                                {/* <td className='py-2'>{technicalInwards.HeadCode}</td> */}
                                                                <td className='py-2'>{technicalInwards.Proposal_year}</td>
                                                                {/* <td className='py-2'>{technicalInwards.SchemeName}</td> */}
                                                                <td className='py-2'>{technicalInwards.District}</td>
                                                                <td className="py-2">{technicalInwards.Taluka}</td>
                                                                <td style={{ padding: "8px" }}>
₹{Number(technicalInwards?.TotalProposalAmount || 0).toLocaleString("en-IN")}
</td>
                                                                {/* <td style={{ padding: '8px' }}>
                                                                    <button
                                                                        onClick={() => nav(`/AdminDashboard/ShowMapProposal/${encodeURIComponent(technicalInwards.Work_name)}`)}
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '0.4rem',
                                                                            padding: '6px 10px',
                                                                            fontWeight: '700',
                                                                            fontSize: '13px',
                                                                            color: '#357EDC',
                                                                            backgroundColor: '#E8F0FE',
                                                                            borderRadius: '6px',
                                                                            cursor: 'pointer',
                                                                            transition: 'all 0.2s ease-in-out'
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src='/Go-To-Map32.png'
                                                                            alt='Go to Map'
                                                                            style={{ width: '1rem', height: '1rem' }}
                                                                        />
                                                                        Go to Map
                                                                    </button>
                                                                </td> */}
    
    
                                                            </tr>
                                                        )
                                                    })
                                                )
                                        }
                                                          <tr
                    style={{
                      backgroundColor: "#f0f0f0",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td style={{ textAlign: "right", padding: "10px" }}>
                      Page Total :
                    </td>
                    <td style={{ padding: "10px" }}>
                      ₹ {pageTotal.toLocaleString("en-IN")}
                    </td>
                  </tr>

                  <tr
                    style={{
                      backgroundColor: "#f0f0f0",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td style={{ textAlign: "right", padding: "10px" }}>
                      Gross Total :
                    </td>
                    <td style={{ padding: "10px" }}>
                      ₹ {grossTotal.toLocaleString("en-IN")}
                    </td>
                  </tr>
                                    </tbody>
                                </table>
                            </div>
    
                            <div className='col-12 mt-3'>
    
                                <div
                                    className="my-2 d-flex justify-content-between align-items-center"
                                    style={{ flexWrap: "wrap", fontSize:"18px" }}
                                >
    
    
                                    <p>{t("Showing")} {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}  {t("to")} {Math.min(indexOfLastBill, filteredBills?.length)} {t("of")} {filteredBills?.length} {t("entries")}</p>
                                    <div className="col-6 text-end">
                                        {/* First Page Button */}
                                        <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
                                            &laquo;
                                        </button>
                                        {/* Previous Button */}
                                        <button
                                            onClick={() => setCurrentPage(currentPage - 1)}
                                            disabled={currentPage === 1}
                                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                            &lt;
                                        </button>
    
                                        <button
                                            style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                                        </button>
                                        {/* Next Button */}
                                        <button
                                            onClick={() => setCurrentPage(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                            &gt;
                                        </button>
                                        {/* Last Page Button */}
                                        <button
                                            onClick={() => setCurrentPage(totalPages)}
                                            disabled={currentPage === totalPages}
                                            style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                            &raquo;
                                        </button>
                                    </div>
    
                                    <div className='col-6 text-start' style={{ display: 'flex', justifyContent: 'left' }}>
                                        <button
                                            onClick={() => approveorrejectSelected("Approved")}
                                            disabled={selectedBills.length <= 0 ? true : loading}
                                            className='ms-0'
                                            // onClick={(e) => { SetGenerateToken(false) }}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                                backgroundColor: selectedBills.length <= 0 ? (
                                                    'rgba(141, 141, 141, 0.97)'
                                                ) : ('#39B54A'),
                                                color: 'white', borderRadius: '8px',
                                                cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                            }}
                                        ><img src='/Approve-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? t('Processing...') : t("Approve Selected")}
                                        </button>
    
                                        <button
                                            onClick={() => setRejectpanelhide(2)}
                                            // onClick={(e) => { SetGenerateRejectToken(false) }}
                                            disabled={selectedBills.length <= 0 ? true : loading}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                                background: selectedBills.length <= 0 ? (
                                                    'rgba(141, 141, 141, 0.97)'
                                                ) : ('#C1272D'),
                                                color: 'white', borderRadius: '8px',
                                                cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                            }}
                                        ><img src='/Reject-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? t('Processing...') : t("Reject Selected")}
                                        </button>
    
                                        {/* <button
                                            onClick={() => setRejectpanelhide(3)} disabled={selectedBills.length <= 0 ? true : loading}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '3px', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                                background: selectedBills.length <= 0 ? (
                                                    'rgba(141, 141, 141, 0.97)'
                                                ) : ('linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)'),
                                                color: 'white', borderRadius: '8px',
                                                cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                            }}
                                        ><img src='/Send-Back-Selected32.png' style={{ width: '1rem', height: "1rem", filter: 'brightness(0) invert(1)' }} /> {loading ? t('Processing...') : t("Send Back Selected")}
                                        </button> */}
                                    </div>
                                </div>
                            </div>
                        </div>
    
                    </div>
    
    
                    {
                        rejectPanelhide === 2 &&
    
                        <div className='col-12 RejectPanelContainer'>
                            <div className="Rejectpanel">
                                <form action="">
    
                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-3">
                                                <label className='fw-bold'>{t("Remark")} <span className='text-danger'>*</span></label>
                                            </div>
                                            <div className="col-8">
                                                <textarea name="" id="" placeholder={t("Enter Remark")} onChange={(e) => setRemark(e.target.value)}>
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>
    
                                </form>
                                <div className="col-12 ms-auto my-4">
                                    <div className="row">
                                        <div className="col-9 m-auto">
                                            <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                                                <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")}><img src={submit} style={{ width: '15px' }} />{t("Reject")}</button>
                                                <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />{t("Cancel")}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                        </div>
    
                    }
    
                    {
                        rejectPanelhide === 3 &&
    
                        <div className='col-12 RejectPanelContainer'>
                            <div className="Rejectpanel">
                                <form action="">
    
                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-3">
                                                <label className='fw-bold'>{t("Remark")} <span className='text-danger'>*</span></label>
                                            </div>
                                            <div className="col-8">
                                                <textarea name="" id="" placeholder={t("Enter Remark")} onChange={(e) => setRemark(e.target.value)}>
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>
    
                                </form>
                                <div className="col-12 ms-auto my-4">
                                    <div className="row">
                                        {/* <div className="col-3"></div> */}
                                        <div className="col-9 m-auto">
                                            <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                                                <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("SendBack")}><img src={submit} style={{ width: '15px' }} /> {t("Send Back")}</button>
                                                <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />{t("Cancel")}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
    
                    {/* <div className="card">
                                <div style={{ position: "fixed", padding: "10rem", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} hidden={GenerateToken}>
                                    <div class="card-body" style={{ backgroundColor: "white", width: "50%" }}>
                                        <h6>Send Message</h6>
                                        <div class="card form-control" style={{ width: "100%" }}>
                                            <div class="card-body">
                                                <h5 class="card-title">Generate Token</h5>
                                                <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
                                                <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>
            
                                            </div>
                                        </div>
                                        <button
                                            onClick={() => approveorrejectSelected("Approved")} hidden={hide}
                                            style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '12px', padding: '8px 15px', background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
                                        ><img style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
                                        </button>
                                        <button className='btn btn-success mx-2 my-2' onClick={() => Approve(selectedType)} hidden={hide} >Approve</button>
                                        <button className='btn btn-danger' onClick={(x) => { SetGenerateToken(true); SetEtoken("") }}>close</button>
                                    </div>
                                </div>
                            </div>
            
                            <div className="card">
                                <div style={{ position: "fixed", padding: "10rem", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} hidden={GenerateRejectToken}>
                                    <div class="card-body" style={{ backgroundColor: "white" }}>
                                        <h6>Send Message</h6>
                                        <div class="card form-control" style={{ width: "100%" }}>
                                            <div class="card-body">
                                                <h5 class="card-title">Generate Token</h5>
                                                <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
                                                <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>
                                            </div>
                                        </div>
                                        <div className="form-group my-3">
                                            <label htmlFor="remark">Remark (Required for Rejection):</label>
                                            <textarea className='form-control' name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
                                            </textarea>
                                        </div>
                                        <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")} hidden={hide} ><img src={submit} style={{ width: '15px' }} /> Reject</button>
                                        <button className='btn btn-success mx-2' onClick={() => Reject(selectedType)} hidden={hide} >Reject</button>
                                        <button className='btn btn-danger' onClick={(x) => { SetGenerateRejectToken(true); SetEtoken("") }}>close</button>
                                    </div>
                                </div>
                            </div> */}
    
                </div >
    
            </>
        )
}

export default ProposalInwardStateWise;

//--> old code
// import React, { useState, useEffect, useContext } from "react";
// import AdminContext from "../../StateContext/Application";
// import { apiurl } from "../../../../path";
// import { Link, useNavigate } from "react-router-dom";
// import "./rejectpanel.css";
// import {
//   Back32,
//   Cancel32,
//   ProposalCreation32,
//   submit,
// } from "../../../../public/LoginImages/importimages";
// import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
// import GooglePagination from "../../styles/GooglePagination";

// const ProposalInwardStateWise = () => {
//   const { language, toggleLanguage, t } = useLanguage();
//   const context = useContext(AdminContext);
//   const {GetBudgetHeadInfo, GetProposalInwardsList, ProposalApprovalOperation, CreateToken } =
//     context;

//   const nav = useNavigate();
//   const [SelectedOptions, setSelectedOptions] = useState("");
//   const [technicalInwards, setTechnicalInwards] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [rejectPanelhide, setRejectpanelhide] = useState(1);
//   const [remark, setRemark] = useState("");
//   const [selectedBills, setSelectedBills] = useState([]);
//   const [filteredBills, setFilteredBills] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const billsPerPage = 10;
//   const [searchTerm, setSearchTerm] = useState("");
//   const [districtList, setDistrictList] = useState([]);
//   const [AllDistrict, setAllDistrict] = useState([]); 
//       const [openDistrict, setOpenDistrict] = useState(false);
//      const [SelectedDistrict, setSelectedDistrict] = useState([]); // Array for multiple districts
 
//   const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
//   const indexOfLastBill = currentPage * billsPerPage;
//   const indexOfFirstBill = indexOfLastBill - billsPerPage;
//   //    const sortedBills = Array.isArray(filteredBills)? filteredBills.slice() // ✅ prevent state mutation
//   // .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
//   //         : [];
//   const sortedBills = filteredBills;
//   const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
//   // const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
//   const [hide, sethide] = useState(true);
//   const [Etoken, SetEtoken] = useState(false);
//   const [GenerateToken, SetGenerateToken] = useState(true);
//   const [GenerateRejectToken, SetGenerateRejectToken] = useState(true);
//   const [selectedWorkNames, setSelectedWorkNames] = useState([]);
//   const [selectedHeadCode, setSelectedHeadCode] = useState("");

//   async function GenerateTokenFor(e) {
//     e.preventDefault();
//     let data = await CreateToken("Proposal Approval");
//     document.getElementById("tokencopys").innerText = data;
//     SetEtoken(data);
//     sethide(false);
//   }

//   const getTechnicalInwardsList = async () => {
//     let data = await GetProposalInwardsList("State", "All");
//     console.log("data------------", data);

//     setTechnicalInwards(data);
//     setFilteredBills(data);
//   };

//   useEffect(() => {
//     getTechnicalInwardsList();
//   }, []);

//   let inwardList = [];
//   if (technicalInwards.length > 0) {
//     inwardList = technicalInwards;
//   }

//    useEffect(() => {
//       const lowerSearchTerm = searchTerm.toLowerCase().trim();
  
//       const filtered = technicalInwards.filter((bill) => {
  
//           // ================= SEARCH FILTER =================
//           const matchesSearch =
//               lowerSearchTerm === "" ||
//               Object.values(bill).some((val) =>
//                   String(val ?? "")
//                       .toLowerCase()
//                       .includes(lowerSearchTerm)
//               );
  
//           // ================= HEAD CODE FILTER =================
//           const matchesHeadCode =
//               selectedHeadCode === "" ||
//               String(bill.HeadCode ?? "").startsWith(selectedHeadCode);
  
//           // ================= DISTRICT FILTER =================
//           const matchesDistrict =
//               SelectedDistrict.length === 0 ||
//               SelectedDistrict.some(
//                   (district) =>
//                       String(bill.District ?? "").trim() ===
//                       String(district ?? "").trim()
//               );
  
//           return (
//               matchesSearch &&
//               matchesHeadCode &&
//               matchesDistrict
//           );
//       });
  
//       setFilteredBills(filtered);
//       setCurrentPage(1);
  
//   }, [
//       searchTerm,
//       selectedHeadCode,
//       SelectedDistrict,
//       technicalInwards
//   ]);
//      useEffect(() => {
//           const fetchDistricts = async () => {
//               try {
//                   const res = await GetBudgetHeadInfo('null', "AllDistrict");
//                   // Get unique districts from the ulb table result
//                   const uniqueDistricts = [...new Set(res.map(item => item.District_Marathi))].filter(Boolean);
//                   setDistrictList(uniqueDistricts);
//                   setAllDistrict(uniqueDistricts);
//               } catch (err) { console.error(err); }
//           };
//           fetchDistricts();
//       }, []);
  
//           const handleDistrictToggle = (district) => {
//           setSelectedDistrict(prev => {
//               const newSelection = prev.includes(district)
//                   ? prev.filter(d => d !== district)
//                   : [...prev, district];
  
//               // Reset Taluka if selection changes
//               // setSelectedTaluka("");
//               return newSelection;
//           });
//       };
  
//       const toggleAllDistricts = () => {
//           if (SelectedDistrict.length === districtList.length) {
//               setSelectedDistrict([]);
//           } else {
//               setSelectedDistrict([...districtList]);
//           }
//           // setSelectedTaluka("");
//       };
  
//       const isAllSelected = SelectedDistrict.length === districtList.length && districtList.length > 0;

//   //--> old code
//   // useEffect(() => {
//   //   let filtered = [...technicalInwards];

//   //   // Filter by status
//   //   if (SelectedOptions) {
//   //     filtered = filtered.filter((item) => item.Status === SelectedOptions);
//   //   }

//   //   // Filter by search term
//   //   if (searchTerm.trim() !== "") {
//   //     const lowerSearchTerm = searchTerm.toLowerCase();

//   //     filtered = filtered.filter((bill) =>
//   //       Object.values(bill).some((val) =>
//   //         (val || "").toString().toLowerCase().includes(lowerSearchTerm),
//   //       ),
//   //     );
//   //   }

//   //   setFilteredBills(filtered);
//   //   setCurrentPage(1);
//   // }, [searchTerm, technicalInwards, SelectedOptions]);

//   // const handleCheckboxChange = (id) => {
//   //     setSelectedBills((prevSelected) =>
//   //         prevSelected.includes(id)
//   //             ? prevSelected.filter((billId) => billId !== id)
//   //             : [...prevSelected, id]
//   //     );
//   // };

//   const handleCheckboxChange = (proposalId, workName) => {
//     if (selectedBills.includes(proposalId)) {
//       setSelectedBills(selectedBills.filter((id) => id !== proposalId));
//       setSelectedWorkNames(
//         selectedWorkNames.filter((name) => name !== workName),
//       );
//     } else {
//       setSelectedBills([...selectedBills, proposalId]);
//       setSelectedWorkNames([...selectedWorkNames, workName]);
//     }
//   };

//   console.log("Slected id form table :: ", selectedBills);
//   console.log("Filtered data id form table :: ", filteredBills);

//   const handleSelectAll = (event) => {
//     if (event.target.checked) {
//       setSelectedBills(currentBills.map((bill) => bill.ProposalID));
//       setSelectedWorkNames(currentBills.map((bill) => bill.Work_name));
//     } else {
//       setSelectedBills([]);
//       setSelectedWorkNames([]);
//     }
//   };

//   const approveorrejectSelected = async (condition) => {
//     if (selectedBills.length === 0) {
//       alert("No Proposal selected for approval!");
//       return;
//     }
//     console.log(selectedBills);
//     setLoading(true); // Start loader

//     try {
//       let response = await ProposalApprovalOperation(
//         selectedBills,
//         condition,
//         remark,
//         Etoken,
//         selectedWorkNames,
//       ); // Call backend function
//       if (response.message) {
//         alert(response.message);
//         window.location.reload();
//         setRemark("");
//         setRejectpanelhide(false);
//         getTechnicalInwardsList(); // Refresh the list after approval
//       }
//       if (response.error) {
//         alert(response.error);
//         window.location.reload();
//         getTechnicalInwardsList(); // Refresh the list after approval
//       }
//     } catch (error) {
//       console.error("Error approving Proposal:", error);
//       alert("An error occurred while approving bills.");
//     }
//     setLoading(false); // Stop loader
//   };

//   // return (
//   //     <>

//   //         <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>

//   //             <div className='col-12 px-3 m-auto'>

//   //                 <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//   //                     {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
//   //                     <h5 className='my-auto fw-bold'>
//   //                         <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
//   //                         <span className='my-auto'>Proposal Approval ( State Wise )</span>
//   //                     </h5>
//   //                     {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)}
//   //                                 value={searchTerm}
//   //                                 style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}

//   //                     <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
//   //                         <img
//   //                             src="/Search32.png"
//   //                             alt="Search Icon"
//   //                             style={{
//   //                                 position: "absolute",
//   //                                 top: "50%",
//   //                                 left: "10px",
//   //                                 transform: "translateY(-50%)",
//   //                                 width: "16px",
//   //                                 height: "16px",
//   //                                 opacity: 0.6
//   //                             }}
//   //                         />
//   //                         <input
//   //                             type="text"
//   //                             placeholder="Search Here"
//   //                             onChange={(e) => setSearchTerm(e.target.value)}
//   //                             value={searchTerm}
//   //                             style={{
//   //                                 width: "100%",
//   //                                 padding: "8px 12px 8px 32px", // left padding makes space for icon
//   //                                 border: "1px solid #ccc",
//   //                                 borderRadius: "8px",
//   //                                 backgroundColor: "#f1f6fc",
//   //                                 fontSize: "14px",
//   //                                 color: "#333",
//   //                                 boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//   //                                 outline: "none"
//   //                             }}
//   //                         />
//   //                     </div>
//   //                 </div>

//   //                 <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "30px 30px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
//   //                     <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
//   //                         <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
//   //                             <thead>
//   //                                 <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//   //                                     {/* <th style={{ width: "4%", textAlign: "center" }} >
//   //                                         <input
//   //                                             type="checkbox"
//   //                                             onChange={handleSelectAll}
//   //                                             checked={selectedBills.length > 0 && selectedBills.length === currentBills.length}
//   //                                             className='my-auto'
//   //                                             style={{ height: '1rem', width: '1rem' }}
//   //                                         />
//   //                                     </th> */}
//   //                                     <th style={{ width: "8%" }}>View</th>
//   //                                     <th style={{ width: "10%" }}>Proposal ID</th>
//   //                                     <th style={{ width: "8%" }}>HeadCode</th>
//   //                                     <th style={{ width: "8%" }}>Proposal Year</th>
//   //                                     {/* <th style={{ width: "10%" }}>Scheme Name</th> */}
//   //                                     <th style={{ width: "8%" }}>District</th>
//   //                                     <th style={{ width: "10%" }}>Total Proposal Amount</th>
//   //                                     {/* <th style={{ width: "10%" }}>Location</th> */}

//   //                                 </tr>
//   //                             </thead>
//   //                             <tbody>
//   //                                 {
//   //                                     currentBills.length <= 0 ?
//   //                                         (
//   //                                             <tr>
//   //                                                 <td colSpan="30" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//   //                                                     No data available
//   //                                                 </td>
//   //                                             </tr>
//   //                                         )
//   //                                         :
//   //                                         (
//   //                                             currentBills?.map((technicalInwards, index) => {
//   //                                                 const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//   //                                                 return (
//   //                                                     <tr style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }} key={index}>
//   //                                                         {/* <td style={{ textAlign: "center" }}>
//   //                                                             <input
//   //                                                                 type="checkbox"
//   //                                                                 className='my-auto'
//   //                                                                 style={{ height: '1rem', width: '1rem' }}
//   //                                                                 checked={selectedBills.includes(technicalInwards.ProposalID)}
//   //                                                                 onChange={() => handleCheckboxChange(technicalInwards.ProposalID, technicalInwards.Work_name)}
//   //                                                             />
//   //                                                         </td> */}
//   //                                                         <td className='py-2'>
//   //                                                             <button
//   //                                                                 onClick={() => nav(`/AdminDashboard/ProposalApprove/${technicalInwards.workuniqueid}?page=${currentPage}`, {
//   //                                                                     state: {
//   //                                                                         type: "State"
//   //                                                                     }
//   //                                                                 })}
//   //                                                                 className='m-auto text-center'
//   //                                                                 style={{
//   //                                                                     width: "4rem", fontWeight: "600", padding: "7px 3px", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.1rem",
//   //                                                                     background: 'linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)',
//   //                                                                     color: 'white', borderRadius: '8px',
//   //                                                                 }}
//   //                                                             > <img src='/view32.png' style={{ width: '0.9rem', height: "0.9rem", filter: 'brightness(0) invert(1)' }} />
//   //                                                                 View
//   //                                                             </button>
//   //                                                         </td>
//   //                                                         <td className='py-2'>{technicalInwards.workuniqueid}</td>
//   //                                                         <td className='py-2'>{technicalInwards.HeadCode}</td>
//   //                                                         <td className='py-2'>{technicalInwards.Proposal_year}</td>
//   //                                                         {/* <td className='py-2'>{technicalInwards.SchemeName}</td> */}
//   //                                                         <td className='py-2'>{technicalInwards.District}</td>
//   //                                                         <td style={{ padding: '8px' }}>{`${technicalInwards.TotalProposalAmount}`}</td>
//   //                                                         {/* <td style={{ padding: '8px' }}>
//   //                                                             <button
//   //                                                                 onClick={() => nav(`/AdminDashboard/ShowMapProposal/${encodeURIComponent(technicalInwards.Work_name)}`)}
//   //                                                                 style={{
//   //                                                                     display: 'flex',
//   //                                                                     alignItems: 'center',
//   //                                                                     gap: '0.4rem',
//   //                                                                     padding: '6px 10px',
//   //                                                                     fontWeight: '700',
//   //                                                                     fontSize: '13px',
//   //                                                                     color: '#357EDC',
//   //                                                                     backgroundColor: '#E8F0FE',
//   //                                                                     borderRadius: '6px',
//   //                                                                     cursor: 'pointer',
//   //                                                                     transition: 'all 0.2s ease-in-out'
//   //                                                                 }}
//   //                                                             >
//   //                                                                 <img
//   //                                                                     src='/Go-To-Map32.png'
//   //                                                                     alt='Go to Map'
//   //                                                                     style={{ width: '1rem', height: '1rem' }}
//   //                                                                 />
//   //                                                                 Go to Map
//   //                                                             </button>
//   //                                                         </td> */}

//   //                                                     </tr>
//   //                                                 )
//   //                                             })
//   //                                         )
//   //                                 }
//   //                             </tbody>
//   //                         </table>
//   //                     </div>

//   //                     <div className='col-12 mt-3'>

//   //                         <div
//   //                             className="my-2 d-flex justify-content-between align-items-center"
//   //                             style={{ flexWrap: "wrap" }}
//   //                         >

//   //                             <p>Showing {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}  to {Math.min(indexOfLastBill, filteredBills?.length)} of {filteredBills?.length} entries</p>
//   //                             <div className="col-6 text-end">
//   //                                 {/* First Page Button */}
//   //                                 <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
//   //                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
//   //                                     &laquo;
//   //                                 </button>
//   //                                 {/* Previous Button */}
//   //                                 <button
//   //                                     onClick={() => setCurrentPage(currentPage - 1)}
//   //                                     disabled={currentPage === 1}
//   //                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
//   //                                     &lt;
//   //                                 </button>

//   //                                 <button
//   //                                     style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
//   //                                 </button>
//   //                                 {/* Next Button */}
//   //                                 <button
//   //                                     onClick={() => setCurrentPage(currentPage + 1)}
//   //                                     disabled={currentPage === totalPages}
//   //                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
//   //                                     &gt;
//   //                                 </button>
//   //                                 {/* Last Page Button */}
//   //                                 <button
//   //                                     onClick={() => setCurrentPage(totalPages)}
//   //                                     disabled={currentPage === totalPages}
//   //                                     style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
//   //                                     &raquo;
//   //                                 </button>
//   //                             </div>

//   //                             <div className='col-6 text-start' style={{ display: 'flex', justifyContent: 'left' }}>
//   //                                 <button
//   //                                     onClick={() => approveorrejectSelected("Approved")}
//   //                                     disabled={selectedBills.length <= 0 ? true : loading}
//   //                                     className='ms-0'
//   //                                     // onClick={(e) => { SetGenerateToken(false) }}
//   //                                     style={{
//   //                                         display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
//   //                                         backgroundColor: selectedBills.length <= 0 ? (
//   //                                             'rgba(141, 141, 141, 0.97)'
//   //                                         ) : ('#39B54A'),
//   //                                         color: 'white', borderRadius: '8px',
//   //                                         cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
//   //                                     }}
//   //                                 ><img src='/Approve-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
//   //                                 </button>

//   //                                 <button
//   //                                     onClick={() => setRejectpanelhide(2)}
//   //                                     // onClick={(e) => { SetGenerateRejectToken(false) }}
//   //                                     disabled={selectedBills.length <= 0 ? true : loading}
//   //                                     style={{
//   //                                         display: 'flex', alignItems: 'center', gap: '0.3rem', margin: '12px', padding: '8px 10px', fontWeight: "600",
//   //                                         background: selectedBills.length <= 0 ? (
//   //                                             'rgba(141, 141, 141, 0.97)'
//   //                                         ) : ('#C1272D'),
//   //                                         color: 'white', borderRadius: '8px',
//   //                                         cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
//   //                                     }}
//   //                                 ><img src='/Reject-Selected32.png' style={{ width: '1rem', height: '1rem', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Reject Selected'}
//   //                                 </button>

//   //                                 <button
//   //                                     onClick={() => setRejectpanelhide(3)} disabled={selectedBills.length <= 0 ? true : loading}
//   //                                     style={{
//   //                                         display: 'flex', alignItems: 'center', gap: '3px', margin: '12px', padding: '8px 10px', fontWeight: "600",
//   //                                         background: selectedBills.length <= 0 ? (
//   //                                             'rgba(141, 141, 141, 0.97)'
//   //                                         ) : ('linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)'),
//   //                                         color: 'white', borderRadius: '8px',
//   //                                         cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
//   //                                     }}
//   //                                 ><img src='/Send-Back-Selected32.png' style={{ width: '1rem', height: "1rem", filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Send Back Selected'}
//   //                                 </button>
//   //                             </div>
//   //                         </div>
//   //                     </div>
//   //                 </div>

//   //             </div>

//   //             {
//   //                 rejectPanelhide === 2 &&

//   //                 <div className='col-12 RejectPanelContainer'>
//   //                     <div className="Rejectpanel">
//   //                         <form action="">

//   //                             <div className="col-12 elements">
//   //                                 <div className="row">
//   //                                     <div className="col-3">
//   //                                         <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
//   //                                     </div>
//   //                                     <div className="col-8">
//   //                                         <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
//   //                                         </textarea>
//   //                                     </div>
//   //                                 </div>
//   //                             </div>

//   //                         </form>
//   //                         <div className="col-12 ms-auto my-4">
//   //                             <div className="row">
//   //                                 <div className="col-9 m-auto">
//   //                                     <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
//   //                                         <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")}><img src={submit} style={{ width: '15px' }} /> Reject</button>
//   //                                         <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
//   //                                     </div>
//   //                                 </div>
//   //                             </div>
//   //                         </div>
//   //                     </div>

//   //                 </div>

//   //             }

//   //             {
//   //                 rejectPanelhide === 3 &&

//   //                 <div className='col-12 RejectPanelContainer'>
//   //                     <div className="Rejectpanel">
//   //                         <form action="">

//   //                             <div className="col-12 elements">
//   //                                 <div className="row">
//   //                                     <div className="col-3">
//   //                                         <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
//   //                                     </div>
//   //                                     <div className="col-8">
//   //                                         <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
//   //                                         </textarea>
//   //                                     </div>
//   //                                 </div>
//   //                             </div>

//   //                         </form>
//   //                         <div className="col-12 ms-auto my-4">
//   //                             <div className="row">
//   //                                 {/* <div className="col-3"></div> */}
//   //                                 <div className="col-9 m-auto">
//   //                                     <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
//   //                                         <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("SendBack")}><img src={submit} style={{ width: '15px' }} /> Send Back</button>
//   //                                         <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
//   //                                     </div>
//   //                                 </div>
//   //                             </div>
//   //                         </div>
//   //                     </div>
//   //                 </div>
//   //             }

//   //             {/* <div className="card">
//   //                         <div style={{ position: "fixed", padding: "10rem", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} hidden={GenerateToken}>
//   //                             <div class="card-body" style={{ backgroundColor: "white", width: "50%" }}>
//   //                                 <h6>Send Message</h6>
//   //                                 <div class="card form-control" style={{ width: "100%" }}>
//   //                                     <div class="card-body">
//   //                                         <h5 class="card-title">Generate Token</h5>
//   //                                         <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
//   //                                         <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>

//   //                                     </div>
//   //                                 </div>
//   //                                 <button
//   //                                     onClick={() => approveorrejectSelected("Approved")} hidden={hide}
//   //                                     style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '12px', padding: '8px 15px', background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
//   //                                 ><img style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
//   //                                 </button>
//   //                                 <button className='btn btn-success mx-2 my-2' onClick={() => Approve(selectedType)} hidden={hide} >Approve</button>
//   //                                 <button className='btn btn-danger' onClick={(x) => { SetGenerateToken(true); SetEtoken("") }}>close</button>
//   //                             </div>
//   //                         </div>
//   //                     </div>

//   //                     <div className="card">
//   //                         <div style={{ position: "fixed", padding: "10rem", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} hidden={GenerateRejectToken}>
//   //                             <div class="card-body" style={{ backgroundColor: "white" }}>
//   //                                 <h6>Send Message</h6>
//   //                                 <div class="card form-control" style={{ width: "100%" }}>
//   //                                     <div class="card-body">
//   //                                         <h5 class="card-title">Generate Token</h5>
//   //                                         <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
//   //                                         <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>
//   //                                     </div>
//   //                                 </div>
//   //                                 <div className="form-group my-3">
//   //                                     <label htmlFor="remark">Remark (Required for Rejection):</label>
//   //                                     <textarea className='form-control' name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
//   //                                     </textarea>
//   //                                 </div>
//   //                                 <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")} hidden={hide} ><img src={submit} style={{ width: '15px' }} /> Reject</button>
//   //                                 <button className='btn btn-success mx-2' onClick={() => Reject(selectedType)} hidden={hide} >Reject</button>
//   //                                 <button className='btn btn-danger' onClick={(x) => { SetGenerateRejectToken(true); SetEtoken("") }}>close</button>
//   //                             </div>
//   //                         </div>
//   //                     </div> */}

//   //         </div >

//   //     </>
//   // )
//   return (
//     <>
//       <div
//         className="col-12"
//         style={{
//           backgroundColor: "#EFF3F8",
//           height: "90vh",
//           overflowX: "hidden",
//           overflowY: "scroll",
//         }}
//       >
//         <div className="col-12 px-3 m-auto">
//           <div className="row px-4 mb-4 mt-3 align-items-center">
//             {/* Title */}
//             <div className="col-lg-8 d-flex align-items-center">
//               <img
//                 src="/GR-Approval64.png"
//                 alt="Technical Approval"
//                 style={{ width: "24px", height: "24px" }}
//                 className="me-2"
//               />
//               <h5 className="fw-bold mb-0">
//                 {t("Proposal Inward ( State Wise )")}
//               </h5>
//             </div>

       
//           </div>
//                       {/* Filters */}
//            <div className="row px-4 mb-4 mt-3 align-items-center">
//     <div
//         style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "flex-end",
//             gap: "10px",
//             flexWrap: "nowrap",
//         }}
//     >

//         {/* ================= HEAD CODE ================= */}
//         <select
//             className="form-select"
//             value={selectedHeadCode}
//             onChange={(e) => setSelectedHeadCode(e.target.value)}
//             style={{
//                 width: "130px",
//                 height: "40px",
//                 border: "1px solid #ccc",
//                 borderRadius: "8px",
//                 fontSize: "13px",
//                 flexShrink: 0,
//             }}
//         >
//             <option value="">
//                 {t("All HeadCodes")}
//             </option>

//             <option value="3054">
//                 3054-2419 (Roads & Bridge Repair)
//             </option>

//             <option value="2515">
//                 2515-1238 (MLA Representative)
//             </option>
//         </select>


//         {/* ================= STATUS ================= */}
//         <select
//             className="form-select"
//             value={SelectedOptions}
//             onChange={(e) => setSelectedOptions(e.target.value)}
//             style={{
//                 width: "150px",
//                 height: "40px",
//                 border: "1px solid #ccc",
//                 borderRadius: "8px",
//                 fontSize: "13px",
//                 flexShrink: 0,
//             }}
//         >
//             <option value="">
//                 {t("All")}
//             </option>

//             <option value="Pending">
//                 {t("Approve")}
//             </option>

//             <option value="SendBack">
//                 {t("Send Back")}
//             </option>
//         </select>


//         {/* ================= DISTRICT ================= */}
//         <div
//             style={{
//                 position: "relative",
//                 width: "180px",
//                 flexShrink: 0,
//             }}
//         >
//             <div
//                 onClick={() => setOpenDistrict(!openDistrict)}
//                 style={{
//                     width: "100%",
//                     height: "40px",
//                     padding: "0 12px",
//                     border: "1px solid #ccc",
//                     borderRadius: "8px",
//                     cursor: "pointer",
//                      background: "#fff",
//                     fontSize: "13px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     boxSizing: "border-box",
//                 }}
//             >
//                 <span
//                     style={{
//                         overflow: "hidden",
//                         whiteSpace: "nowrap",
//                         textOverflow: "ellipsis",
//                     }}
//                 >
//                     {SelectedDistrict.length > 0
//                         ? SelectedDistrict.length === 1
//                             ? SelectedDistrict[0]
//                             : `${SelectedDistrict.length} ${t("Districts Selected")}`
//                         : t("Select District")}
//                 </span>

//             </div>


//             {openDistrict && (
//                 <div
//                     style={{
//                         position: "absolute",
//                         top: "45px",
//                         left: 0,
//                         width: "200px",
//                         backgroundColor: "#fff",
//                         border: "1px solid #ccc",
//                         borderRadius: "8px",
//                         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                         zIndex: 9999,
//                         overflow: "hidden",
//                     }}
//                 >

//                     {/* ALL DISTRICTS */}
//                     <label
//                         style={{
//                             display: "flex",
//                             alignItems: "center",
//                             padding: "10px 12px",
//                             borderBottom: "1px solid #eee",
//                             cursor: "pointer",
//                             fontSize: "13px",
//                             // fontWeight: "600",
//                         }}
//                     >
//                         <input
//                             type="checkbox"
//                             checked={isAllSelected}
//                             onChange={toggleAllDistricts}
//                             style={{
//                                 marginRight: "8px",
//                                 width: "15px",
//                                 height: "15px",
//                             }}
//                         />

//                         {t("All Districts")}
//                     </label>


//                     {/* DISTRICT LIST */}
//                     <div
//                         style={{
//                             maxHeight: "200px",
//                             overflowY: "auto",
//                         }}
//                     >
//                         {districtList.map((dist, index) => (
//                             <label
//                                 key={index}
//                                 style={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     padding: "8px 12px",
//                                     cursor: "pointer",
//                                     fontSize: "13px",
//                                 }}
//                             >
//                                 <input
//                                     type="checkbox"
//                                     checked={SelectedDistrict.includes(dist)}
//                                     onChange={() =>
//                                         handleDistrictToggle(dist)
//                                     }
//                                     style={{
//                                         marginRight: "8px",
//                                         width: "15px",
//                                         height: "15px",
//                                     }}
//                                 />

//                                 <span>{dist}</span>
//                             </label>
//                         ))}
//                     </div>


//                     {/* OK BUTTON */}
//                     <div
//                         style={{
//                             borderTop: "1px solid #eee",
//                             padding: "8px",
//                             textAlign: "right",
//                         }}
//                     >
//                         <button
//                             type="button"
//                             onClick={() => setOpenDistrict(false)}
//                             style={{
//                                 padding: "6px 15px",
//                                 fontSize: "12px",
//                                 borderRadius: "6px",
//                                 border: "none",
//                                 background: "#0d6efd",
//                                 color: "#fff",
//                                 cursor: "pointer",
//                             }}
//                         >
//                             {t("OK")}
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </div>


//         {/* ================= SEARCH ================= */}
//         <div
//             style={{
//                 position: "relative",
//                 width: "200px",
//                 flexShrink: 0,
//             }}
//         >
//             <img
//                 src="/Search32.png"
//                 alt="Search"
//                 style={{
//                     position: "absolute",
//                     top: "50%",
//                     left: "12px",
//                     transform: "translateY(-50%)",
//                     width: "16px",
//                     height: "16px",
//                     opacity: 0.6,
//                 }}
//             />

//             <input
//                 type="text"
//                 className="form-control"
//                 placeholder={t("Search Here")}
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 style={{
//                     width: "100%",
//                     height: "40px",
//                     paddingLeft: "36px",
//                     backgroundColor: "#f1f6fc",
//                     border: "1px solid #ccc",
//                     borderRadius: "8px",
//                     fontSize: "13px",
//                     boxSizing: "border-box",
//                 }}
//             />
//         </div>

//     </div>
// </div>

//           <div
//             className="m-auto"
//             style={{
//               width: "98%",
//               backgroundColor: "white",
//               padding: "30px 30px",
//               boxShadow: "0px 0px 5px 1px #c7c9cc",
//               borderRadius: "20px",
//             }}
//           >
//             <div
//               className="col-12 tableDesign"
//               style={{ background: "#2C78DB" }}
//             >
//               <table
//                 className="m-0 p-0"
//                 style={{ width: "100%", borderCollapse: "collapse" }}
//               >
//                 <thead>
//                   <tr
//                     style={{
//                       color: "white",
//                       border: "none",
//                       height: "3rem",
//                       fontSize: "18px",
//                     }}
//                   >
//                     {/* <th style={{ width: "4%", textAlign: "center" }} >
//                                                 <input
//                                                     type="checkbox"
//                                                     onChange={handleSelectAll}
//                                                     checked={selectedBills.length > 0 && selectedBills.length === currentBills.length}
//                                                     className='my-auto'
//                                                     style={{ height: '1rem', width: '1rem' }}
//                                                 />
//                                             </th> */}
//                     <th style={{ width: "8%" }}>{t("View")}</th>
//                     <th style={{ width: "10%" }}>{t("Proposal File No")}</th>
//                     {/* <th style={{ width: "8%" }}>{t("HeadCode")}</th> */}
//                     <th style={{ width: "8%" }}>{t("Proposal Year")}</th>
//                     {/* <th style={{ width: "10%" }}>Scheme Name</th> */}
//                     <th style={{ width: "8%" }}>{t("District")}</th>
//                     <th style={{ width: "10%" }}>
//                       {t("Total Proposal Amount")}
//                     </th>
//                     {/* <th style={{ width: "10%" }}>Location</th> */}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentBills.length <= 0 ? (
//                     <tr>
//                       <td
//                         colSpan="30"
//                         style={{
//                           textAlign: "center",
//                           padding: "20px",
//                           backgroundColor: "#f9f9f9",
//                         }}
//                       >
//                         {t("No data available")}
//                       </td>
//                     </tr>
//                   ) : (
//                     currentBills?.map((technicalInwards, index) => {
//                       const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                       return (
//                         <tr
//                           style={{
//                             backgroundColor: bgColor,
//                             fontSize: "18px",
//                             fontWeight: "500",
//                           }}
//                           key={index}
//                         >
//                           {/* <td style={{ textAlign: "center" }}>
//                                                                     <input
//                                                                         type="checkbox"
//                                                                         className='my-auto'
//                                                                         style={{ height: '1rem', width: '1rem' }}
//                                                                         checked={selectedBills.includes(technicalInwards.ProposalID)}
//                                                                         onChange={() => handleCheckboxChange(technicalInwards.ProposalID, technicalInwards.Work_name)}
//                                                                     />
//                                                                 </td> */}
//                           <td className="py-2">
//                             <button
//                               onClick={() =>
//                                 nav(
//                                   `/AdminDashboard/ProposalApprove/${technicalInwards.workuniqueid}?page=${currentPage}`,
//                                   {
//                                     state: {
//                                       type: "State",
//                                     },
//                                   },
//                                 )
//                               }
//                               className="m-auto text-center"
//                               style={{
//                                 width: "4rem",
//                                 fontWeight: "600",
//                                 padding: "7px 3px",
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                                 gap: "0.1rem",
//                                 background:
//                                   "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
//                                 color: "white",
//                                 borderRadius: "8px",
//                               }}
//                             >
//                               {" "}
//                               <img
//                                 src="/view32.png"
//                                 style={{
//                                   width: "0.9rem",
//                                   height: "0.9rem",
//                                   filter: "brightness(0) invert(1)",
//                                 }}
//                               />
//                               {t("View")}
//                             </button>
//                           </td>
//                           <td className="py-2">
//                             {technicalInwards.Proposal_fileNumber}
//                           </td>
//                           {/* <td className='py-2'>{technicalInwards.HeadCode}</td> */}
//                           <td className="py-2">
//                             {technicalInwards.Proposal_year}
//                           </td>
//                           {/* <td className='py-2'>{technicalInwards.SchemeName}</td> */}
//                           <td className="py-2">{technicalInwards.District}</td>
//                           <td
//                             style={{ padding: "8px" }}
//                           >{`${technicalInwards.TotalProposalAmount}`}</td>
//                           {/* <td style={{ padding: '8px' }}>
//                                                                     <button
//                                                                         onClick={() => nav(`/AdminDashboard/ShowMapProposal/${encodeURIComponent(technicalInwards.Work_name)}`)}
//                                                                         style={{
//                                                                             display: 'flex',
//                                                                             alignItems: 'center',
//                                                                             gap: '0.4rem',
//                                                                             padding: '6px 10px',
//                                                                             fontWeight: '700',
//                                                                             fontSize: '13px',
//                                                                             color: '#357EDC',
//                                                                             backgroundColor: '#E8F0FE',
//                                                                             borderRadius: '6px',
//                                                                             cursor: 'pointer',
//                                                                             transition: 'all 0.2s ease-in-out'
//                                                                         }}
//                                                                     >
//                                                                         <img
//                                                                             src='/Go-To-Map32.png'
//                                                                             alt='Go to Map'
//                                                                             style={{ width: '1rem', height: '1rem' }}
//                                                                         />
//                                                                         Go to Map
//                                                                     </button>
//                                                                 </td> */}
//                         </tr>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             <div className="col-12 mt-3">
//               <div
//                 className="my-2 d-flex justify-content-between align-items-center"
//                 style={{ flexWrap: "wrap" }}
//               >
//                 <p style={{ fontSize: "18px" }}>
//                   {t("Showing")}{" "}
//                   {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
//                   {t("to")} {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
//                   {t("of")} {filteredBills?.length} {t("entries")}
//                 </p>

//                   <div className="col-6 text-end">
//                     <GooglePagination
//                       currentPage={currentPage}
//                       totalPages={totalPages}
//                       onPageChange={setCurrentPage}
//                     />
//                   </div>

//                 {/* <div className="col-6 text-end">
//                   <button
//                     onClick={() => setCurrentPage(1)}
//                     disabled={currentPage === 1}
//                     style={{
//                       backgroundColor: "white",
//                       color: "black",
//                       border: "1px solid lightgrey",
//                       cursor: "pointer",
//                       fontSize: "20px",
//                       width: "2rem",
//                     }}
//                   >
//                     &laquo;
//                   </button>
//                   <button
//                     onClick={() => setCurrentPage(currentPage - 1)}
//                     disabled={currentPage === 1}
//                     style={{
//                       backgroundColor: "white",
//                       color: "black",
//                       border: "1px solid lightgrey",
//                       cursor: "pointer",
//                       fontSize: "20px",
//                       borderLeft: "none",
//                       width: "2rem",
//                     }}
//                   >
//                     &lt;
//                   </button>

//                   <button
//                     style={{
//                       background:
//                         "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
//                       color: "white",
//                       cursor: "pointer",
//                       fontSize: "20px",
//                       width: "2.4rem",
//                       border: "1px solid lightgrey",
//                       borderLeft: "none",
//                     }}
//                   >
//                     {currentPage}
//                   </button>
//                   <button
//                     onClick={() => setCurrentPage(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                     style={{
//                       backgroundColor: "white",
//                       color: "black",
//                       border: "1px solid lightgrey",
//                       cursor: "pointer",
//                       fontSize: "20px",
//                       borderLeft: "none",
//                       width: "2rem",
//                     }}
//                   >
//                     &gt;
//                   </button>
//                   <button
//                     onClick={() => setCurrentPage(totalPages)}
//                     disabled={currentPage === totalPages}
//                     style={{
//                       backgroundColor: "white",
//                       color: "black",
//                       border: "1px solid lightgrey",
//                       cursor: "pointer",
//                       fontSize: "20px",
//                       borderLeft: "none",
//                       width: "2rem",
//                     }}
//                   >
//                     &raquo;
//                   </button>
//                 </div> */}

//                 <div
//                   className="col-6 text-start"
//                   style={{ display: "flex", justifyContent: "left" }}
//                 >
//                   <button
//                     onClick={() => approveorrejectSelected("Approved")}
//                     disabled={selectedBills.length <= 0 ? true : loading}
//                     className="ms-0"
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.3rem",
//                       margin: "12px",
//                       padding: "8px 10px",
//                       fontWeight: "600",
//                       backgroundColor:
//                         selectedBills.length <= 0
//                           ? "rgba(141, 141, 141, 0.97)"
//                           : "#39B54A",
//                       color: "white",
//                       borderRadius: "8px",
//                       cursor:
//                         selectedBills.length <= 0
//                           ? "not-allowed"
//                           : loading
//                             ? "not-allowed"
//                             : "pointer",
//                     }}
//                   >
//                     <img
//                       src="/Approve-Selected32.png"
//                       style={{
//                         width: "1rem",
//                         height: "1rem",
//                         filter: "brightness(0) invert(1)",
//                       }}
//                     />{" "}
//                     {loading ? t("Processing...") : t("Approve Selected")}
//                   </button>

//                   <button
//                     onClick={() => setRejectpanelhide(2)}
//                     disabled={selectedBills.length <= 0 ? true : loading}
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.3rem",
//                       margin: "12px",
//                       padding: "8px 10px",
//                       fontWeight: "600",
//                       background:
//                         selectedBills.length <= 0
//                           ? "rgba(141, 141, 141, 0.97)"
//                           : "#C1272D",
//                       color: "white",
//                       borderRadius: "8px",
//                       cursor:
//                         selectedBills.length <= 0
//                           ? "not-allowed"
//                           : loading
//                             ? "not-allowed"
//                             : "pointer",
//                     }}
//                   >
//                     <img
//                       src="/Reject-Selected32.png"
//                       style={{
//                         width: "1rem",
//                         height: "1rem",
//                         filter: "brightness(0) invert(1)",
//                       }}
//                     />{" "}
//                     {loading ? t("Processing...") : t("Reject Selected")}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {rejectPanelhide === 2 && (
//           <div className="col-12 RejectPanelContainer">
//             <div className="Rejectpanel">
//               <form action="">
//                 <div className="col-12 elements">
//                   <div className="row">
//                     <div className="col-3">
//                       <label className="fw-bold">
//                         {t("Remark")} <span className="text-danger">*</span>
//                       </label>
//                     </div>
//                     <div className="col-8">
//                       <textarea
//                         name=""
//                         id=""
//                         placeholder={t("Enter Remark")}
//                         onChange={(e) => setRemark(e.target.value)}
//                       ></textarea>
//                     </div>
//                   </div>
//                 </div>
//               </form>
//               <div className="col-12 ms-auto my-4">
//                 <div className="row">
//                   <div className="col-9 m-auto">
//                     <div
//                       className="col-12"
//                       style={{
//                         display: "flex",
//                         gap: "10px",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <button
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: "4px",
//                           background:
//                             "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                           width: "5rem",
//                           height: "2rem",
//                           fontSize: "18px",
//                         }}
//                         onClick={() => approveorrejectSelected("Rejected")}
//                       >
//                         <img src={submit} style={{ width: "15px" }} />
//                         {t("Reject")}
//                       </button>
//                       <button
//                         type="button"
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: "4px",
//                           backgroundColor: "#f1594c",
//                           width: "6rem",
//                           height: "2rem",
//                           fontSize: "16px",
//                         }}
//                         onClick={() => window.location.reload()}
//                       >
//                         {" "}
//                         <img src={Cancel32} style={{ width: "17px" }} />
//                         {t("Cancel")}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {rejectPanelhide === 3 && (
//           <div className="col-12 RejectPanelContainer">
//             <div className="Rejectpanel">
//               <form action="">
//                 <div className="col-12 elements">
//                   <div className="row">
//                     <div className="col-3">
//                       <label className="fw-bold">
//                         {t("Remark")} <span className="text-danger">*</span>
//                       </label>
//                     </div>
//                     <div className="col-8">
//                       <textarea
//                         name=""
//                         id=""
//                         placeholder={t("Enter Remark")}
//                         onChange={(e) => setRemark(e.target.value)}
//                       ></textarea>
//                     </div>
//                   </div>
//                 </div>
//               </form>
//               <div className="col-12 ms-auto my-4">
//                 <div className="row">
//                   {/* <div className="col-3"></div> */}
//                   <div className="col-9 m-auto">
//                     <div
//                       className="col-12"
//                       style={{
//                         display: "flex",
//                         gap: "10px",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <button
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: "4px",
//                           background:
//                             "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                           width: "8rem",
//                           height: "2rem",
//                           fontSize: "18px",
//                         }}
//                         onClick={() => approveorrejectSelected("SendBack")}
//                       >
//                         <img src={submit} style={{ width: "15px" }} />{" "}
//                         {t("Send Back")}
//                       </button>
//                       <button
//                         type="button"
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: "4px",
//                           backgroundColor: "#f1594c",
//                           width: "6rem",
//                           height: "2rem",
//                           fontSize: "16px",
//                         }}
//                         onClick={() => window.location.reload()}
//                       >
//                         {" "}
//                         <img src={Cancel32} style={{ width: "17px" }} />
//                         {t("Cancel")}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* <div className="card">
//                                 <div style={{ position: "fixed", padding: "10rem", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} hidden={GenerateToken}>
//                                     <div class="card-body" style={{ backgroundColor: "white", width: "50%" }}>
//                                         <h6>Send Message</h6>
//                                         <div class="card form-control" style={{ width: "100%" }}>
//                                             <div class="card-body">
//                                                 <h5 class="card-title">Generate Token</h5>
//                                                 <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
//                                                 <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>
            
//                                             </div>
//                                         </div>
//                                         <button
//                                             onClick={() => approveorrejectSelected("Approved")} hidden={hide}
//                                             style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '12px', padding: '8px 15px', background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
//                                         ><img style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
//                                         </button>
//                                         <button className='btn btn-success mx-2 my-2' onClick={() => Approve(selectedType)} hidden={hide} >Approve</button>
//                                         <button className='btn btn-danger' onClick={(x) => { SetGenerateToken(true); SetEtoken("") }}>close</button>
//                                     </div>
//                                 </div>
//                             </div>
            
//                             <div className="card">
//                                 <div style={{ position: "fixed", padding: "10rem", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(5px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} hidden={GenerateRejectToken}>
//                                     <div class="card-body" style={{ backgroundColor: "white" }}>
//                                         <h6>Send Message</h6>
//                                         <div class="card form-control" style={{ width: "100%" }}>
//                                             <div class="card-body">
//                                                 <h5 class="card-title">Generate Token</h5>
//                                                 <textarea class="form-control" id='tokencopys' value={Etoken}></textarea>
//                                                 <button hidden={Etoken} className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={GenerateTokenFor}>Generate Token</button>
//                                             </div>
//                                         </div>
//                                         <div className="form-group my-3">
//                                             <label htmlFor="remark">Remark (Required for Rejection):</label>
//                                             <textarea className='form-control' name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
//                                             </textarea>
//                                         </div>
//                                         <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '5rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("Rejected")} hidden={hide} ><img src={submit} style={{ width: '15px' }} /> Reject</button>
//                                         <button className='btn btn-success mx-2' onClick={() => Reject(selectedType)} hidden={hide} >Reject</button>
//                                         <button className='btn btn-danger' onClick={(x) => { SetGenerateRejectToken(true); SetEtoken("") }}>close</button>
//                                     </div>
//                                 </div>
//                             </div> */}
//       </div>
//     </>
//   );
// };

// export default ProposalInwardStateWise;
